import { render } from "./CopyPriceWindowModal.vue?vue&type=template&id=fcb67dae&scoped=true&ts=true"
import script from "./CopyPriceWindowModal.vue?vue&type=script&lang=ts"
export * from "./CopyPriceWindowModal.vue?vue&type=script&lang=ts"

import "./CopyPriceWindowModal.vue?vue&type=style&index=0&id=fcb67dae&scoped=true&lang=css"

import exportComponent from "../../../node_modules/vue-loader/dist/exportHelper.js"
const __exports__ = /*#__PURE__*/exportComponent(script, [['render',render],['__scopeId',"data-v-fcb67dae"]])

export default __exports__